import { useAppStore } from '@/store';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t } = useTranslation();
  const { setDepositOpen, setWithdrawOpen } = useAppStore();
  return (
    <div className="flex justify-center gap-x-[76px] mb-[30px]">
      <div className="flex flex-col items-center gap-y-[8px]">
        <div className="size-[44px] flex items-center justify-center bg-themeColor rounded-full" onClick={() => setDepositOpen(true)}>
          <ArrowDown className="text-[#000]" />
        </div>
        <span className="text-[14px]">{t('Account.deposit')}</span>
      </div>
      <div className="flex flex-col items-center gap-y-[8px]">
        <div className="size-[44px] flex items-center justify-center bg-themeColor rounded-full" onClick={() => setWithdrawOpen(true)}>
          <ArrowUp className="text-[#000]" />
        </div>
        <span className="text-[14px]">{t('Account.withdraw')}</span>
      </div>
    </div>
  );
};
